import React from "react";
import { ReactComponent as CloseIcon } from "../../assets/cross-color.svg";
import "./CloseButton.css";

const CloseButton = ({
  className,
  styles = {},
  size = 24,
  transform = "scale(2.3)",
  onClose,
}) => {
  return (
    <button className="close-button" style={{ ...styles }} onClick={onClose}>
      <CloseIcon style={{ width: size, height: size, transform }} />
    </button>
  );
};

export default CloseButton;
